/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-06 18:56:08
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-02-12 15:19:39
 * @Description: file content
 * 上传
 * 需要接口index.html atob 和 npm install ali-oss
 */
import * as comreq from "@/utils/comreq";
import global_ from "../global.config";

function toBlob(urlData, fileType) {
  var bytes = window.atob(urlData),
    n = bytes.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bytes.charCodeAt(n);
  }
  return new Blob([u8arr], { type: fileType });
}
function uploadBase64ToOss(data) {
  const OSS = require("ali-oss");
  return new Promise(function (resolve, reject) {
    // 图像数据 (e.g. data:image/png;base64,iVBOR...yssDuN70DiAAAAABJRU5ErkJggg==)
    var dataUrl = data;
    var base64 = dataUrl.split(',')[1];
    var fileType = dataUrl.split(';')[0].split(':')[1];

    // base64转blob
    var blob = toBlob(base64, fileType);

    // blob转arrayBuffer
    var reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onload = function (event) {

      comreq.aliyunActionSts().then((res) => {
        var result = res.obj
        var client = new OSS({
          accessKeyId: result.credentials.accessKeyId,
          accessKeySecret: result.credentials.accessKeySecret,
          stsToken: result.credentials.securityToken,
          endpoint: result.endpoint,
          bucket: result.bucket
        })
        // 文件名
        var storeAs = result.dir + '/' + global_.hdkXcxAppId + '/h5_create_share_img/' + Date.parse(new Date()) + '.' + blob.type.split('/')[1];

        // arrayBuffer转Buffer
        var buffer = new OSS.Buffer(event.target.result);

        // 上传
        client.put(storeAs, buffer).then(function (result) {
          // 如果要压缩图片 后面加 ?x-oss-process=image/resize,m_fixed,h_400,w_300
          var needUrl = result.url;
          needUrl = needUrl.replace("yqweb.oss-cn-shanghai.aliyuncs.com", "assets.rurushishi.com");
          resolve(needUrl);
        }).catch(function (err) {
          console.log(err);
          alert("当前网络不稳定，请稍候再试！")
        });
      })

    }
  })
}
export default {
  uploadBase64ToOss
}
